import React, { Children, ReactNode } from 'react';

const childrenWithProps = ({ children, additionalProps }: { children: ReactNode; additionalProps: object }) =>
  Children.map(children, (child) => {
    switch (typeof child) {
      case 'string':
        return child;
      case 'object':
        return React.cloneElement(child as React.ReactElement<any>, additionalProps);
      default:
        return null;
    }
  });

export default childrenWithProps;
